export default __webpack_public_path__ + "static/media/booting.fd7d6a16.svg";